import {defineStore, type StoreDefinition} from "pinia";
import {type ProfileStoreState, state} from "@/store/profile/state";
import {actions, type ProfileStoreActions} from "@/store/profile/actions";

export type ProfileStoreType = StoreDefinition<string, ProfileStoreState, any, ProfileStoreActions>;

export const useProfileStore: ProfileStoreType = defineStore('profileStore', {
    state,
    actions
});
